var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-agregar-linea"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "agregar-linea",
    clipPath: "url(#clip-agregar-linea)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2005",
    "data-name": "Grupo 2005",
    transform: "translate(-4.747 11.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 66.729,
    height: 66.729,
    transform: "translate(0 0.001)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(10.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_31ca992b-8a09-4ca3-abf8-0bdcfe234c7a",
    "data-name": "31ca992b-8a09-4ca3-abf8-0bdcfe234c7a",
    d: "M2,0H44.71a2,2,0,0,1,2,2L29.82,48.592c0,.074-.585,1.692-.7,2.191-.861,2.278-4.682,13.053-5.381,14.447L2,66.729a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    fill: "none",
    stroke: "#bebebe",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "_2dea4e17-238e-4109-acfa-6fa9c5e478c3",
    "data-name": "2dea4e17-238e-4109-acfa-6fa9c5e478c3",
    x2: 0.033,
    transform: "translate(23.355 53.383)",
    fill: "none",
    stroke: "#bebebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon-3",
    "data-name": "Icon",
    transform: "translate(46.787 0) rotate(20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area-2",
    "data-name": "Area",
    width: 66.729,
    height: 66.729,
    transform: "translate(0 0.001)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-4",
    "data-name": "Icon",
    transform: "translate(10.01 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_31ca992b-8a09-4ca3-abf8-0bdcfe234c7a-2",
    "data-name": "31ca992b-8a09-4ca3-abf8-0bdcfe234c7a",
    width: 46.71,
    height: 66.729,
    rx: 2,
    fill: "none",
    stroke: "#bebebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "_2dea4e17-238e-4109-acfa-6fa9c5e478c3-2",
    "data-name": "2dea4e17-238e-4109-acfa-6fa9c5e478c3",
    x2: 0.033,
    transform: "translate(23.355 53.383)",
    fill: "none",
    stroke: "#bebebe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLine);
export default __webpack_public_path__ + "static/media/add-line.b7a920e69cf0b2276ca1af5c2d43a56b.svg";
export { ForwardRef as ReactComponent };